import NoProfile from "src/assets/images/user-default.png";

export const noProfile = NoProfile;

export const baseUrl = process.env.REACT_APP_API_BASE_URL;
export const userBaseUrl = process.env.REACT_APP_USER_BASE_URL;

export const apiUrl = baseUrl + "/api";
export const outerPages = ["/", "/login", "/workspaces", "/logout/callback", "/workspaces/", "/permission-denied", "/no-content/", "/token/", "/forgot-password", "/forgot-password/", "/logout", "/forgot-password"];
